import { createIcon } from '@chakra-ui/react';

export const SaudeIcon = createIcon({
  displayName: 'SaudeIcon',
  viewBox: '0 0 32 38',
  path: [
    <path
      key="1"
      d="M14.3212 22.666C6.42439 22.666 0 16.4076 0 8.71487V-7.62939e-06H6.86894C7.63981 -7.62939e-06 8.26545 0.609009 8.26545 1.36042C8.26545 2.11137 7.63981 2.72084 6.86894 2.72084H2.79301V8.71487C2.79301 14.9075 7.96473 19.9452 14.3212 19.9452C20.6776 19.9452 25.8493 14.9075 25.8493 8.71487V2.72084H22.4912C21.7203 2.72084 21.0947 2.11137 21.0947 1.36042C21.0947 0.609009 21.7203 -7.62939e-06 22.4912 -7.62939e-06H28.6423V8.71487C28.6423 16.4076 22.2179 22.666 14.3212 22.666Z"
      fill="#0066F3"
    />,
    <path
      key="2"
      d="M20.3336 38.0001C15.7522 38.0001 12.0249 34.3692 12.0249 29.9061V21.3055C12.0249 20.554 12.6501 19.945 13.4214 19.945C14.1927 19.945 14.8179 20.554 14.8179 21.3055V29.9061C14.8179 32.8691 17.2921 35.2793 20.3336 35.2793C23.3748 35.2793 25.8494 32.8691 25.8494 29.9061V25.9731C25.8494 25.2217 26.4745 24.6126 27.2459 24.6126C28.0172 24.6126 28.6424 25.2217 28.6424 25.9731V29.9061C28.6424 34.3692 24.9151 38.0001 20.3336 38.0001Z"
      fill="#0066F3"
    />,
    <path
      key="3"
      d="M32 24.8131C32 27.3712 29.8713 29.4445 27.2458 29.4445C24.62 29.4445 22.4912 27.3712 22.4912 24.8131C22.4912 22.2551 24.62 20.1818 27.2458 20.1818C29.8713 20.1818 32 22.2551 32 24.8131Z"
      fill="#65E5AE"
    />
  ]
});
